import React from 'react';
import { VEHICLES, getVehicleDisplayName } from '../data/bookingConfig';
import '../styles/VehicleFleet.css';

const FLEET_CARDS = [
  {
    type: 'Sedan',
    available: 'Dzire • Etios • Amaze • Aura',
    seats: '4 + 1 Seats',
    ride: 'Comfort Ride',
    image: '/images/vehicle/suzuki-dzire-1.webp',
  },
  {
    type: 'SUV',
    available: 'Innova • Ertiga • Carens • Xylo',
    seats: '7 + 1 Seats',
    ride: 'Spacious Ride',
    image: '/images/innova-car.webp',
  },
  {
    type: 'MUV',
    available: 'Innova Crysta',
    seats: '7 + 1 Seats',
    ride: 'Premium Ride',
    image: '/images/innova-crysta.webp',
  },
];

const VehicleFleet = () => {
  const vehicles = FLEET_CARDS.map((card) => {
    const pricing = VEHICLES.find((item) => item.type === card.type);
    return {
      ...card,
      rate: pricing?.rate,
    };
  });

  return (
    <section className="vehicle-fleet">
      <div className="container">
        <h2 className="vehicle-fleet-title">Our Vehicle Fleet</h2>
        <div className="vehicle-fleet-grid">
          {vehicles.map((vehicle) => (
            <article key={vehicle.type} className="vehicle-card-item">
              <div className="vehicle-image-container">
                <img
                  className="vehicle-image"
                  src={vehicle.image}
                  alt={`${getVehicleDisplayName(vehicle)} taxi`}
                />
              </div>
              <div className="vehicle-card-content">
                <h3 className="vehicle-card-name">{getVehicleDisplayName(vehicle)}</h3>
                <p className="vehicle-available-label">Available:</p>
                <p className="vehicle-available-models">{vehicle.available}</p>
                <div className="vehicle-spec-row">
                  <span className="vehicle-spec-seats">{vehicle.seats}</span>
                  <span className="vehicle-spec-rate">₹{vehicle.rate}/km</span>
                </div>
                <div className="vehicle-spec-row vehicle-spec-row-secondary">
                  <span>AC</span>
                  <span>{vehicle.ride}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VehicleFleet;
